import { Button, Grid, Typography } from "@material-ui/core";
import Header from "../Header";
import Routes from "../../routes";
import Footer from "../Footer";
import { useHistory, useLocation } from "react-router";
import Joyride, { STATUS } from "react-joyride";
import { useState } from "react";
import { useEffect } from "react";
import { steps } from "./TourSteps";
import {
	setMessagingOpenMobileBlur,
	setMyActivityFilterDrawerOpenMobile,
	setSearchFilterDrawerOpen,
	setSearchFilterDrawerOpenMobile,
	setTour,
} from "routes/actions";
import { useDispatch, useSelector } from "react-redux";
import { setOpenConsultantDialog, setOpenMessageDialog } from "screens/Messaging/actions";
import { useInjectReducer } from "utilize/injectReducer";
import { useInjectSaga } from "utilize/injectSaga";
import reducer from "routes/reducer";
import saga from "routes/saga";

export default function MasterLayout() {
	useInjectReducer({ key: "main", reducer });
	useInjectSaga({ key: "main", saga });

	const location = useLocation();
	const history = useHistory();
	const tour = useSelector((state) => state?.main?.tour);
	const dispatch = useDispatch();
	const [state, setState] = useState({ run: false, stepIndex: 0, steps: [], tourActive: false });

	const currentUser = useSelector((state) => state?.main?.currentUser);

	const handleCallback = (data) => {
		const { action, index, lifecycle, type, step } = data;
		if (type === "step:after" && step.target === ".home_newest_activity" && action !== "skip") {
			dispatch(setTour({ ...tour, run: false }));
			history.push("/activities");
		} else if (
			type === "step:after" &&
			step.target === ".activities_my_boom_activity_like_count" &&
			action !== "skip"
		) {
			history.push("/activities/search");
			if (window.innerWidth < 768) {
				dispatch(setSearchFilterDrawerOpenMobile(true));
				//style  to tabs in activities page in mobile when tour is run
				document.querySelector(".activities_tabs_container_mobile").style = "z-index:100000 !important";
			} else {
				dispatch(setSearchFilterDrawerOpen(true));
			}
		} else if (type === "step:before" && step.target === ".activities_search_filter_mobile" && action !== "skip") {
			//style  to tabs in activities page in mobile when tour is run
			document.querySelector(".activities_tabs_container_mobile").style = "z-index:1000 !important";
		} else if (type === "step:after" && step.target === ".activities_search_filter" && action !== "skip") {
			history.push("/activities/myactivity");
		} else if (type === "step:after" && step.target === ".activities_search_filter_mobile" && action !== "skip") {
			dispatch(setMyActivityFilterDrawerOpenMobile(true));
			document.querySelector(".activities_tabs_container_mobile").style = "z-index:100000 !important";
			history.push("/activities/myactivity");
		} else if (
			type === "step:after" &&
			step.target === ".activities_my_activities_checkbox_fail" &&
			action !== "skip"
		) {
			history.push("/activities/myFollow");
		} else if (
			type === "step:before" &&
			step.target === ".activities_my_activities_checkbox_mobile" &&
			action !== "skip"
		) {
			document.querySelector(".activities_tabs_container_mobile").style = "z-index:1000 !important";
		} else if (
			type === "step:after" &&
			step.target === ".activities_my_activities_checkbox_mobile" &&
			action !== "skip"
		) {
			history.push("/activities/myFollow");
		} else if (type === "step:after" && step.target === ".activities_add_activity" && action !== "skip") {
			dispatch(setTour({ ...tour, run: false }));
			history.push("/add-activity");
		} else if (type === "step:after" && step.target === ".add_activity_save" && action !== "skip") {
			dispatch(setTour({ ...tour, run: false }));
			history.push("/league");
		} else if (type === "step:after" && step.target === ".league_item_score" && action !== "skip") {
			dispatch(setTour({ ...tour, run: false }));
			history.push("/messaging/inbox");
		} else if (type === "step:after" && step.target === ".messaging_inbox_search" && action !== "skip") {
			history.push("/messaging/send");
		} else if (type === "step:after" && step.target === ".messaging_sendBox" && action !== "skip") {
			history.push("/messaging/archive");
		} else if (type === "step:after" && step.target === ".messaging_archive" && action !== "skip") {
			history.push("/messaging/contacts");
		} else if (type === "step:after" && step.target === ".messaging_new_consulting" && action !== "skip") {
			dispatch(setTour({ ...tour, run: false }));
			dispatch(setOpenConsultantDialog(true));
			setTimeout(() => dispatch(setTour({ ...tour, run: true, stepIndex: 55 })), 500);
		} else if (type === "step:after" && step.target === ".messaging_new_consulting_send" && action !== "skip") {
			dispatch(setOpenConsultantDialog(false));
		} else if (type === "step:after" && step.target === ".messaging_new_message" && action !== "skip") {
			dispatch(setTour({ ...tour, run: false }));
			dispatch(setOpenMessageDialog(true));
			setTimeout(() => dispatch(setTour({ ...tour, run: true, stepIndex: 60 })), 500);
		} else if (type === "step:after" && step.target === ".messaging_new_message_send" && action !== "skip") {
			dispatch(setTour({ ...tour, run: false }));
			dispatch(setOpenMessageDialog(false));
			setTimeout(() => dispatch(setTour({ ...tour, run: true, stepIndex: 64 })), 500);
			history.push(`/profile/${currentUser?.slug}`);
		} else if (type === "step:after" && step.target === ".my_profile_user_boom" && action !== "skip") {
			dispatch(setTour({ ...tour, run: false }));
			history.push(`/associations${currentUser?.roles[0]?.url}`);
		} else if (action === "skip") {
			dispatch(setTour({ ...tour, run: false, tourActive: false }));
		}
	};
	const CustomTooltip = ({ index, size, step, skipProps, primaryProps, tooltipProps, isLastStep, backProps }) => {
		return (
			<Grid
				container="container"
				direction="column"
				{...tooltipProps}
				style={{
					background: "linear-gradient(100deg, #1b6fbe -11%, #0ebca0 85%)",
					padding: "20px",
					borderRadius: 10,
					maxWidth: "95vw",
				}}
			>
				<Grid container>{step?.content}</Grid>
				<Grid container justify="center" style={{ marginTop: "20px" }}>
					<Button variant="contained" {...backProps}>
						قبلی
					</Button>
					{isLastStep ? (
						<Button variant="contained" {...skipProps}>
							تمام
						</Button>
					) : (
						<Button variant="contained" {...primaryProps}>
							بعدی
						</Button>
					)}
					<Button variant="outlined" {...skipProps}>
						بستن
					</Button>
				</Grid>
			</Grid>
		);
	};

	useEffect(() => {
		setState({
			...state,
			steps: steps,
		});
	}, []);

	useEffect(() => {
		console.log(location.pathname, "location.pathname");
		console.log("tour activity 1");
		switch (location.pathname) {
			case "/activities":
				if (tour?.tourActive) {
					setTimeout(() => {
						dispatch(setTour({ ...tour, run: true, stepIndex: 4 }));
					}, 500);
				}
				break;
			case "/add-activity":
				if (tour?.tourActive) {
					setTimeout(() => {
						dispatch(setTour({ ...tour, run: true, stepIndex: 21 }));
					}, 500);
				}
				break;
			case "/league":
				if (tour?.tourActive) {
					setTimeout(() => {
						dispatch(setTour({ ...tour, run: true, stepIndex: 35 }));
					}, 500);
				}
				break;
			case "/messaging/inbox":
				if (tour?.tourActive) {
					setTimeout(() => {
						dispatch(setTour({ ...tour, run: true, stepIndex: 47 }));
					}, 500);
				}
				break;
			case `/associations${currentUser?.roles[0]?.url}`:
				if (tour?.tourActive) {
					setTimeout(() => {
						dispatch(setTour({ ...tour, run: true, stepIndex: 71 }));
					}, 500);
				}
				break;

			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.pathname]);
	return (
		<>
			{location.pathname === "/login" ||
			location.pathname === "/forgetpassword" ||
			location.pathname === "/signup" ? (
				<Routes />
			) : (
				<Grid
					container
					direction="column"
					justify="space-between"
					style={{ minHeight: "100vh", backgroundColor: "#eeeeee", position: "relative" }}
				>
					<Header />
					<Grid container style={{ flex: 1, overflow: "hidden" }}>
						<Routes />
						<Joyride
							callback={handleCallback}
							continuous
							run={tour?.run}
							stepIndex={tour?.stepIndex}
							steps={steps}
							disableOverlayClose
							showProgress
							styles={{
								options: {
									arrowColor: "#129fab",
									backgroundColor: "#e3ffeb",
									overlayColor: "rgba(0, 0, 0, 0.6)",
									primaryColor: "#000",
									textColor: "#004a14",
									spotlightShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
									width: 900,
									zIndex: 1000,
								},
								spotlight: {
									padding: "10px",
								},
								overlay: {
									zIndex: 10000,
								},
								floater: {
									tooltip: { zIndex: "11000 !important" },
									zIndex: 12000,
								},
								tooltip: {
									zIndex: 12000,
								},
							}}
							floaterProps={{ styles: { floaterOpening: { zIndex: 11000 } } }}
							tooltipComponent={CustomTooltip}
							locale={{ skip: "بستن", next: "بعدی", back: "قبلی" }}
						/>
					</Grid>
					{location.pathname === "/" ? <Footer /> : null}
				</Grid>
			)}
		</>
	);
}
